import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
  gap: 1.6rem;

  @media (max-width: 768px) {
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    position: sticky;
    top: -6%;
    left: 0;
    right: 0;
    background: #f5f5f5;
    z-index: 10;
    padding: 10px 16px;
    /* height: 19vh; */
    padding: 10px 0px;
  }
`;

export const HeaderTitle = styled.h1`
  font-size: 30px;
  font-weight: 700;
  color: #1c1726;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    padding: 0px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
`;

export const CancelButton = styled.button`
  padding: 10px 32px;
  background-color: white;
  color: black;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid black;
  border-radius: 15px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f0f0;
  }

  @media (max-width: 768px) {
    padding: 10px 32px;
  }
`;

export const ContinueButton = styled.button`
  padding: 10px 32px;
  background-color: #1a1a1a;
  color: white;
  font-weight: 700;
  font-size: 14px;
  border: none;
  border-radius: 15px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #000;
  }

  &:disabled {
    background-color: #f0f0f0;
    cursor: not-allowed;
    border: 1px solid #d9d9d9;
    color: #d9d9d9;
  }

  @media (max-width: 768px) {
    padding: 10px 32px;
  }
`;
